"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _connectors = require("@insided/shared/services/algolia/connectors");

var _SearchService = _interopRequireDefault(require("../../../services/SearchService"));

var _preactCompat = require("preact-compat");

var _RefinedTypesContentTabs = require("./RefinedTypesContentTabs");

var _components = require("@insided/shared/services/algolia/components");

var _common = require("@insided/shared/utils/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Compares two tabFacets arrays to check if they are equal.
 * This prevents unnecessary state updates that would cause infinite loops.
 */
function areTabFacetsEqual(a, b) {
  if (a.length !== b.length) return false;
  return a.every(function (tabA, index) {
    var tabB = b[index];
    if (!tabB) return false;
    return tabA.id === tabB.id && tabA.count === tabB.count && tabA.isRefined === tabB.isRefined && tabA.label === tabB.label && tabA.type === tabB.type;
  });
}
/**
 * Gets the count for a specific tab from the main search response facets.
 * Used to show accurate filtered count for the selected tab.
 */


function getMainResponseCountForTab(searchResults, tabLabel, tabType) {
  if (!(searchResults !== null && searchResults !== void 0 && searchResults.facets)) return null;

  if (tabType === 'gs_data_source') {
    var _gsDataSourceFacet$da, _gsDataSourceFacet$da2;

    var gsDataSourceFacet = searchResults.facets.find(function (facet) {
      return facet.name === 'gs_data_source';
    });
    return (_gsDataSourceFacet$da = gsDataSourceFacet === null || gsDataSourceFacet === void 0 ? void 0 : (_gsDataSourceFacet$da2 = gsDataSourceFacet.data) === null || _gsDataSourceFacet$da2 === void 0 ? void 0 : _gsDataSourceFacet$da2[tabLabel]) !== null && _gsDataSourceFacet$da !== void 0 ? _gsDataSourceFacet$da : null;
  }

  if (tabType === 'source') {
    var _sourceFacet$data$tab, _sourceFacet$data;

    var sourceFacet = searchResults.facets.find(function (facet) {
      return facet.name === 'source';
    });
    return (_sourceFacet$data$tab = sourceFacet === null || sourceFacet === void 0 ? void 0 : (_sourceFacet$data = sourceFacet.data) === null || _sourceFacet$data === void 0 ? void 0 : _sourceFacet$data[tabLabel]) !== null && _sourceFacet$data$tab !== void 0 ? _sourceFacet$data$tab : null;
  }

  return null;
}
/**
 * Merges tab facets from secondary calls with counts from main response for selected tab.
 * - Unselected tabs: Show unfiltered count from secondary calls (buildTabFacetsRequests)
 * - Selected tab: Show filtered count from main response (matches totalTopics)
 */


function mergeTabFacetsWithMainResponse(secondaryTabFacets, searchResults) {
  return secondaryTabFacets.map(function (tab) {
    if (!tab.isRefined) {
      // Unselected tab - keep the unfiltered count from secondary call
      return tab;
    } // Selected tab - use count from main response for consistency with totalTopics


    var mainResponseCount = getMainResponseCountForTab(searchResults, tab.label, tab.type);

    if (mainResponseCount !== null) {
      return _objectSpread(_objectSpread({}, tab), {}, {
        count: mainResponseCount
      });
    } // Fallback to secondary call count if main response doesn't have this facet


    return tab;
  });
}
/**
 * Determines the appropriate tab facets based on exhaustiveNbHits flag.
 * - If exhaustiveNbHits is true: Use searchService.tabFacets directly (shows all tabs all the time)
 * - If exhaustiveNbHits is false: Use secondary call facets merged with main response
 *   (secondary call provides facet list, main response provides count for selected tab)
 */


function getTabFacets(searchResults, isUnifiedIndex) {
  if (!isUnifiedIndex) {
    return _SearchService.default.tabFacets;
  } // Check if hit counts are exhaustive (exact)
  // Note: exhaustiveNbHits is an Algolia response property not in react-instantsearch types


  var isExhaustive = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.exhaustiveNbHits) !== false;

  if (isExhaustive) {
    // Exact counts - use searchService.tabFacets directly (shows all tabs all the time)
    return _SearchService.default.tabFacets;
  } // Approximate counts - merge secondary call facets with main response count for selected tab


  return mergeTabFacetsWithMainResponse(_SearchService.default.tabFacets, searchResults);
}

var FilterTabs = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(FilterTabs, _PureComponent);

  var _super = _createSuper(FilterTabs);

  function FilterTabs() {
    var _this;

    (0, _classCallCheck2.default)(this, FilterTabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      tabFacets: []
    });
    return _this;
  }

  (0, _createClass2.default)(FilterTabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // TODO: Revisit this check to see that it runs when there is a change in the search state
      if (!this.props.searching) {
        // Get appropriate tab facets based on exhaustiveFacetsCount flag
        var tabFacets = getTabFacets(this.props.searchResults, _common.common.isModuleActive('unifiedIndexEnabled')); // Only update state if facets have changed to prevent unnecessary re-renders

        if (!areTabFacetsEqual(tabFacets, this.state.tabFacets)) {
          this.setState({
            tabFacets: tabFacets
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var onFilterTabChange = this.props.onFilterTabChange;
      return (0, _preact.h)("div", {
        className: "instant-search__source-type-filter"
      }, !!this.state.tabFacets.length && (0, _preact.h)(_RefinedTypesContentTabs.RefinedTypesContentTabs, {
        tabs: this.state.tabFacets,
        onFilterTabChange: onFilterTabChange
      }), (0, _preact.h)("div", {
        hidden: true
      }, (0, _preact.h)(_components.RefinementList, {
        attribute: "gs_data_source",
        searchable: true,
        limit: 20,
        operator: "and"
      })));
    }
  }]);
  return FilterTabs;
}(_preactCompat.PureComponent);

var _default = (0, _connectors.connectStateResults)(FilterTabs);

exports.default = _default;